export default __webpack_public_path__ + "static/media/flower12.4912df68.jpg";